import { Grid } from '@mui/material';

import { ReactComponent as CloseIcon } from 'common/assets/images/close.svg';
import { toSentenceCase } from 'common/utils/utilFunctions';

import styles from './ControlTestStepModalHeader.module.scss';

interface IControlTestStepModalHeader {
	title: string;
	handleModalClose: () => void;
	ModalHeaderImg?: any;
}
const ControlTestStepModalHeader = (props: IControlTestStepModalHeader) => {
	const { title, handleModalClose, ModalHeaderImg } = props;
	const { closeImgFillColor } = styles;

	const handleClose = () => {
		handleModalClose();
	};

	return (
		<>
			<Grid item xs={11} lg={11} sm={11} md={11}>
				<div className={styles['add-control-test-step-title-div']}>
					{ModalHeaderImg && (
						<ModalHeaderImg
							className={styles['add-control-test-step-title-img']}
						/>
					)}
					<span className={styles['add-control-test-step-title']}>
						{toSentenceCase(title)}
					</span>
				</div>
			</Grid>

			<Grid
				item
				xs={1}
				lg={1}
				sm={1}
				md={1}
				className={styles['add-control-test-step-title-close']}
			>
				<div className={styles['add-control-close-icon']}>
					<CloseIcon
						data-testid="on-close"
						onClick={handleClose}
						fill={closeImgFillColor}
					/>
				</div>
			</Grid>
		</>
	);
};

export default ControlTestStepModalHeader;
